import gql from "graphql-tag";

export default gql`
  query getPublicCommentsByListingId($listingId: Int!) {
    allPublicComments(
      condition: { listingId: $listingId, deletedAt: null }
      orderBy: CREATED_AT_ASC
    ) {
      nodes {
        id
        listingId
        userId
        parentCommentId
        content
        createdAt
        updatedAt
        userByUserId {
          id
          firstname
          lastname
          profilePictureUrl
        }
      }
    }
  }
`;
